import styled from '@emotion/styled'

export const ContentHeader = styled('h1')(({ customCss }) => ({
  fontSize: 'x-large',
  marginBottom: 10,
  color: '#413e52',
  ...customCss,
}))
